<template>
  <div class="animated wow fadeIn">
    <Cards />
    <Icons />
    <Picture />
    <Onas />
  </div>
</template>

<script>
import sku from '@/sku'
import { log } from 'util'
import Cards from '@/components/Cards'
import Icons from '@/components/Icons'
import Picture from '@/components/Picture'
import Onas from '@/components/Onas'

export default {
  name: 'home',
  components: {
    Cards,
    Icons,
    Picture,
    Onas,
  },
  mounted() {
    sku.animateAutoWidthAndHeight('.blue-box')
  }
}
</script>

<style lang="scss" scoped>

</style>
